import { runtimeConfig } from "@src/runtime-config";
import { StellarApiClient } from "@stellar/stellar-api-client";
import { getDashboard20ApiUrl } from "@utils/url-utils";
import { useMemo } from "react";

interface SphereXGApi {
  /** Instance of the stellar api client */
  stellarApiClient: StellarApiClient;
}

/**
 * Hook that provides access to the Stellar API client.
 */
export function useStellarApiClient(): SphereXGApi {
  const stellarApiClient = useMemo(() => {
    /** Url for accessing the Stellar API including numbered dev environment if applies */
    const baseUrl = getDashboard20ApiUrl(
      runtimeConfig.urls.dashboard20Api,
      runtimeConfig.numberedEnv
    );
    return new StellarApiClient({ baseUrl });
  }, []);

  return { stellarApiClient };
}
